import { Link } from "react-router-dom";
import { fmtPrice, resolveImage } from "../lib/api";
import { Bed, Bathtub, ArrowsOutSimple, MapPin } from "@phosphor-icons/react";
import FavoriteButton from "./FavoriteButton";
import CompareCheckbox from "./CompareCheckbox";

export default function PropertyCard({ p, testId }) {
  return (
    <div className="group block relative" data-testid={testId || `property-card-${p.id}`}>
      <div className="absolute top-3 right-3 z-10 flex flex-col gap-1.5">
        <FavoriteButton id={p.id} />
        <CompareCheckbox id={p.id} />
      </div>
      <Link to={`/properties/${p.id}`}>
        <div className="pp-hover-zoom aspect-[4/3] bg-[#ffffff] mb-4 relative">
          {p.images?.[0] ? (
            <img src={resolveImage(p.images[0])} alt={p.title} className="w-full h-full object-cover" loading="lazy" />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-neutral-400">No image</div>
          )}
          {p.listing_type && (
            <div className="absolute top-4 left-4 overline text-white bg-black/70 backdrop-blur-sm px-3 py-1.5">
              {p.listing_type === "off-plan" ? "Off-plan" : p.listing_type}
            </div>
          )}
          {p.featured && (
            <div className="absolute bottom-4 left-4 overline text-white bg-[#001588] px-3 py-1.5">Featured</div>
          )}
        </div>
        <div className="flex items-start justify-between gap-3">
          <div>
            <div className="text-[11px] tracking-[0.24em] uppercase text-[#001588] mb-1.5 flex items-center gap-1.5">
              <MapPin size={12} weight="fill" /> {p.community}
            </div>
            <h3 className="font-serif text-xl leading-tight text-[#050d19] group-hover:text-[#001588] transition-colors">{p.title}</h3>
          </div>
        </div>
        <div className="mt-3 flex items-center gap-4 text-sm text-neutral-500">
          {p.bedrooms > 0 && <span className="flex items-center gap-1.5"><Bed size={14} /> {p.bedrooms} bed</span>}
          {p.bathrooms > 0 && <span className="flex items-center gap-1.5"><Bathtub size={14} /> {p.bathrooms} bath</span>}
          {p.area_sqft > 0 && <span className="flex items-center gap-1.5"><ArrowsOutSimple size={14} /> {Number(p.area_sqft).toLocaleString()} sqft</span>}
        </div>
        <div className="mt-3 pt-3 border-t border-[#e5e7eb] flex items-baseline justify-between">
          <span className="font-serif text-2xl text-[#050d19]">{fmtPrice(p.price, p.currency)}</span>
          {p.price_period && <span className="text-xs text-neutral-500">/ {p.price_period}</span>}
        </div>
      </Link>
    </div>
  );
}
